'use client';
import React, { useEffect } from 'react';
import { ZocPreview } from '@/app/_lib/zoc';
import { TrackerClient } from '@/app/_components/monitoring/tracking';

type trackSharePreviewViewedProps = {
  zocPreview: ZocPreview;
};

const TrackSharePreviewViewed = ({
  zocPreview,
}: trackSharePreviewViewedProps) => {
  useEffect(() => {
    TrackerClient.sharePreviewViewed(zocPreview);
  }, []);

  return <></>;
};

export { TrackSharePreviewViewed };
